import { Box } from '@mui/material'
import { C1CoolDownButton } from 'components/core/button'
import { Decision } from 'components/pages/task/action'
import { TaskActionButtonArgs } from 'components/pages/task/action/button'
import { canActOn } from 'components/pages/task/state'
import { TaskActionType } from 'pbts/c1/api/task/v1/task'
import { FormattedMessage } from 'react-intl'
import { TaskActionButton } from './styles'

type CancelActionButtonProps = TaskActionButtonArgs & {
    show: boolean
}

export const CancelActionButton = ({ task, show, onAction }: CancelActionButtonProps): React.ReactElement | null => {
    const taskId = task.id

    if (!canActOn(task, TaskActionType.CLOSE) || !show) {
        return null
    }

    return <Box sx={TaskActionButton.item}>
        <C1CoolDownButton
            key={`components_task_list_cancel_option_${taskId}`}
            variant="outlined"
            color="primary"
            coolDown={1000}
            onClick={(): void => {
                onAction(
                    {
                        decision: Decision.Cancel,
                        comment: '',
                    },
                    task,
                )
            }}
            disabled={!canActOn(task, TaskActionType.CLOSE)}
        >
            <FormattedMessage id="component_task_list_cancel_option_label" defaultMessage="Cancel" />
        </C1CoolDownButton>
    </Box>
}
